import { EmailConfig, EventRole, OrganizationUser, Role, TechCheck } from '@goldcast/api/backend';

import { FormattedAlert } from '@/studio/alerts/types';

export interface State {
  speakers: Speakers;
  isSpeakerListLoading: boolean;
  selectedSpeakers: Record<string, Speaker>;
  areAllSpeakersSelected: boolean;
  speakerCurrentPage: number;
  speakerColumns: SpeakerColumn[];
  speakerPerPage: number;
  totalSpeakerCount: number;
  isSpeakerEmailConfigLoading: boolean;
  speakerInviteEmailConfig: null | EmailConfig;
  excludedSpeakers: Record<string, Speaker>;
  speakerRolesMap: Record<string, Role>;
  defaultSpeakerRole: null | DefaultSpeakerRole;
  systemUserRolesMap: Record<string, ExtendedRole>;
}

export interface DefaultSpeakerRole {
  id: string;
  role: ExtendedRole;
}

export type SpeakerColumnKey = 'full_name' | 'title' | 'company' | 'email' | 'magic_link' | 'permission';

export interface SpeakerColumn {
  name: string;
  key: SpeakerColumnKey;
  allowFiltering?: boolean;
}

export interface Speaker extends EventRole {
  allow_moderate_chat: boolean;
  allow_moderate_qna: boolean;
  allow_polls_control: boolean;
  allow_screen_share: boolean;
  allow_share_media: boolean;
  allow_share_slides: boolean;
  event: string;
  hidden: boolean;
  id: number;
  rank: number;
  role: 4;
  user: User;
  organization_user: OrganizationUser;
  alertForSpeaker: FormattedAlert[];
  isFetchingMagicLink?: boolean;
}

export interface User {
  company: string;
  description: string;
  email: string;
  first_name: string;
  id: string;
  last_name: string;
  linkedin_url: string;
  profile_picture_url: string | null;
  tech_check: TechCheck;
  title: string;
  twitter_url: string;
  subTitle: string;
  speakerId?: number;
  roles: string[];
  originalSpeakerData?: Speaker;
  role?: ExtendedRole;
}

export type Speakers = {
  [id: string]: Speaker;
};

export interface SpeakerInput {
  email: string;
  firstName: string;
  lastName: string;
  title: string;
  company: string;
  linkedinUrl: string;
  twitterUrl: string;
  description: string;
  profileImage: string | null;
}

export type FormattedAlertForSpeakers = {
  [userId: string]: FormattedAlert[];
};

export interface SpeakerRoleOption {
  value: number;
  label: string;
  priority?: number;
}

export type SpeakerRoleName = 'Full Access' | 'Share Access' | 'Stage Access';

export const predeterminedSpeakerRoles: SpeakerRoleName[] = ['Stage Access', 'Share Access', 'Full Access'];

export enum SpeakerRoleEnum {
  FullAccess = 'Full Access',
  ShareAccess = 'Share Access',
  StageAccess = 'Stage Access'
}

export interface ExtendedRole extends Role {
  priority?: number;
}
